import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = [{
    title: 'Ti manca tempo ogni giorno',
    desc: "Torni a casa stanca dal lavoro e l'ultima cosa che vuoi è passare ore in cucina a pensare cosa preparare."
  }, {
    title: 'Non sai cosa dargli per farlo mangiare sano',
    desc: 'Finisci per ricorrere sempre alle solite cose perché non ti vengono in mente idee nuove e sane.'
  }, {
    title: 'Vuoi che tuo figlio mangi più vario',
    desc: 'Ti preoccupa che la sua alimentazione sia monotona e che gli manchino nutrienti essenziali per la crescita.'
  }, {
    title: 'Spendi troppo in snack confezionati',
    desc: 'I prodotti del supermercato sono sempre più cari e sempre meno sani.'
  }, {
    title: 'Tuo figlio è selettivo con il cibo',
    desc: 'Rifiuta le verdure e provare cose nuove è una battaglia costante a casa.'
  }, {
    title: 'Cerchi praticità senza perdere qualità',
    desc: 'Vuoi opzioni che si possano congelare, preparare velocemente e che restino nutrienti.'
  }];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <div className="text-center mb-12" data-id="element-119">
          <span className="inline-block bg-[#1f2e10] text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider mb-4 uppercase" data-id="element-120">
            Ideale per te
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1f2e10]" data-id="element-121">
            Mamma che:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-122">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex gap-4" data-id="element-123">
              <div className="flex-shrink-0 mt-1" data-id="element-124">
                <CheckCircle2 className="text-green-500" size={24} data-id="element-125" />
              </div>
              <div data-id="element-126">
                <h3 className="font-bold text-lg text-[#1f2e10] mb-2" data-id="element-127">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-128">{point.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}